import clx from 'classnames';
import styles from './HomeSkeletons.module.scss';

const Bone = ({ className }) => <span className={clx(styles.bone, className)} />;

export const HomeInfoCardsSkeleton = ({ isMobile = false }) => (
  <div
    className={clx(styles.cards, { [styles.cards_mobile]: isMobile })}
    aria-busy="true"
    aria-label="loading"
  >
    {[0, 1, 2].map((i) => (
      <div
        key={i}
        className={clx(styles.card, {
          [styles.card_gold]: i === 0,
          [styles.card_green]: i === 1,
          [styles.card_blue]: i === 2,
        })}
      >
        <div className={styles.card_header}>
          <Bone className={styles.card_icon} />
          <div className={styles.card_titles}>
            <Bone className={styles.card_title} />
            <Bone className={styles.card_subtitle} />
          </div>
        </div>
        <div className={styles.card_hero}>
          <Bone className={styles.card_label} />
          <Bone className={styles.card_value} />
        </div>
        <div className={styles.card_grid}>
          <div className={styles.card_tile}>
            <Bone className={styles.card_label} />
            <Bone className={styles.card_tile_value} />
          </div>
          <div className={styles.card_tile}>
            <Bone className={styles.card_label} />
            <Bone className={styles.card_tile_value} />
          </div>
        </div>
      </div>
    ))}
  </div>
);

export const HomeMetricValueSkeleton = ({ wide = false }) => (
  <Bone className={clx(styles.metric_value, { [styles.metric_value_wide]: wide })} />
);

export const HomeTablesSkeleton = ({ isMobile = false }) => (
  <div
    className={clx(styles.tables, { [styles.tables_mobile]: isMobile })}
    aria-busy="true"
    aria-label="loading"
  >
    {[0, 1].map((i) => (
      <div key={i} className={styles.table}>
        <div className={styles.table_header}>
          <Bone className={styles.table_icon} />
          <Bone className={styles.table_title} />
        </div>
        <div className={styles.table_body}>
          {[0, 1, 2, 3].map((row) => (
            <div key={row} className={styles.table_row}>
              <Bone className={styles.table_avatar} />
              <div className={styles.table_text}>
                <Bone className={styles.table_name} />
                <Bone className={styles.table_meta} />
              </div>
            </div>
          ))}
        </div>
      </div>
    ))}
  </div>
);
